import { Modifier } from '@popperjs/core';

export const createTooltipModifiers = (
    offset: [number, number],
): Partial<Modifier<any, any>>[] => [
    {
        name: 'flip',
        enabled: true,
        options: {
            fallbackPlacements: ['bottom', 'right', 'left'],
        },
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            boundary: 'viewport',
            padding: 16,
        },
    },
    {
        name: 'offset',
        options: {
            offset,
        },
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            boundary: 'viewport',
            padding: 16,
            altAxis: true,
        },
    },
];
